import styled from 'styled-components';
export const CookingContainer = styled.div.withConfig({
  displayName: "Cookingstyle__CookingContainer",
  componentId: "sc-u9dbwl-0"
})(["", " max-width:750px;.content{", ";}@media (max-width:", "){", "}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginBottom": "5rem",
  "marginTop": "3rem",
  "width": "100%"
}, {
  "marginTop": "2.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "2.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
});
export const Title = styled.h2.withConfig({
  displayName: "Cookingstyle__Title",
  componentId: "sc-u9dbwl-1"
})(["", ""], {
  "margin": "0px",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(206 14 45 / var(--tw-text-opacity, 1))"
});